import React from "react";

const COGNITO_DOMAIN =
  "https://us-east-1elqlibp38.auth.us-east-1.amazoncognito.com";

const CLIENT_ID = "4tls70cf96vr6fjci4navi8abn";

const REDIRECT_URI = `${window.location.origin}/admin/callback`;

export default function AdminLogin() {
  const loginUrl =
    `${COGNITO_DOMAIN}/login?response_type=code` +
    `&client_id=${CLIENT_ID}` +
    `&redirect_uri=${encodeURIComponent(REDIRECT_URI)}` +
    `&scope=openid+email`;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
      <div className="bg-white p-8 rounded-2xl shadow-md text-center w-full max-w-md border border-gray-200">
        <h2 className="text-xl font-bold mb-2 text-gray-900">
          Inkasso Admin Login
        </h2>
        <p className="text-sm text-gray-600 mb-6">
          Nur für Inkasso – kein Cobot Login.
        </p>

        <button
          onClick={() => (window.location.href = loginUrl)}
          className="w-full px-6 py-3 bg-black text-white rounded-lg font-medium hover:opacity-90"
        >
          Login mit Cognito
        </button>
      </div>
    </div>
  );
}